import Crud from './crud'
import client from './client'

export default class ConstructionShelterService extends Crud {
  constructor (siteId) {
    super(`/site/${siteId}/construction-tower`)
  }

  filter (searchFilter, options) {
    if (options !== undefined) {
      for (const key in options) {
        searchFilter[key] = options[key]
      }
    }
    const url = '/api/construction-tower/filter'
    return client.get(url, searchFilter)
  }
}
